import { CheckoutFormData } from 'models/CheckoutFormData';
import { PageState } from 'models/PageState';
import type { Channels } from 'utils';
import { checkoutForm } from 'views/CheckoutPage/selector';
import { AddressInfo } from 'models/AddressInfo';
import { isCheckoutPage } from 'models/CheckoutPageModel';

const DEFAULT_MAX_NAME_LENGTH = 34;
type FormProps = Pick<CheckoutFormData, 'address' | 'cache' | 'quickStart'>;

export const selectNeedsCertificateId = (state: PageState) => state.cart.needsCertificateId;

export const selectChannel = (state: PageState): Channels => state.appShell.channel as Channels;

export const selectIsQuickStart = (state: PageState): boolean => {
  const checkoutFormData = checkoutForm(state, 'address', 'cache', 'quickStart') as FormProps;
  return checkoutFormData.quickStart;
};

export const selectAddressInfo = ({ currentPage }: PageState): AddressInfo | null => {
  if (!isCheckoutPage(currentPage)) {
    return null;
  }

  return currentPage.addressInfo;
};

export const selectNameMaxLength = ({ currentPage }: PageState): number | undefined => {
  if (!isCheckoutPage(currentPage)) {
    return undefined;
  }

  return !currentPage.initialValues.address
    ? DEFAULT_MAX_NAME_LENGTH
    : currentPage.initialValues.address.maxNameLength;
};
